import React from "react"
import UnitsStyle from "./UnitsStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const Units = ({ handleChangeUnits, units, locale }) => {
  return (
    <div className={UnitsStyle.holder}>
      <p className={UnitsStyle.title}>1. {translate(keys.MY_UNITS, locale)}</p>
      <div className={UnitsStyle.units}>
        <label
          htmlFor="imperial"
          className={
            units === "Imperial"
              ? UnitsStyle.active_unit
              : UnitsStyle.unit_holder
          }
        >
          <input
            id="imperial"
            type="radio"
            value="Imperial"
            checked={units === "Imperial"}
            onChange={handleChangeUnits}
          />
          {translate(keys.IMPERIAL, locale)}
        </label>
        <label
          htmlFor="metric"
          className={
            units === "Metric" ? UnitsStyle.active_unit : UnitsStyle.unit_holder
          }
        >
          <input
            id="metric"
            type="radio"
            value="Metric"
            checked={units === "Metric"}
            onChange={handleChangeUnits}
          />
          {translate(keys.METRIC, locale)}
        </label>
      </div>
    </div>
  )
}

export default Units
